webpackJsonp([2487708015156],{

/***/ 50:
/***/ (function(module, exports) {

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	function LinearEasing (x) {
	  return x;
	}
	
	module.exports = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  if (mX1 === mY1 && mX2 === mY2) {
	    return LinearEasing;
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  for (var i = 0; i < kSplineTableSize; ++i) {
	    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bezierEasing = __webpack_require__(50);
	
	var _bezierEasing2 = _interopRequireDefault(_bezierEasing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var range = function range(a, b) {
	  return Math.round((b - a) * Math.random() + a);
	};
	var easing = (0, _bezierEasing2.default)(0.5, 0, 1, 0.1);
	
	// Set # of items
	var NUM_SHAPES = 18;
	
	// Draw items base on type tri | cir | arc | rec
	
	var Shape = function () {
	  function Shape(options) {
	    _classCallCheck(this, Shape);
	
	    this.startX = range(0, options.maxWidth - 0);
	    this.startY = range(0, options.maxHeight - 0);
	    this.x = this.startX;
	    this.y = this.startY;
	    this.distanceX = range(50, 300);
	    this.distanceY = range(50, 300);
	    this.speed = 1;
	    this.rotate = range(0, 180);
	    this.rotateSpeed = 0.4; //range(1, 2);
	    this.rotateDir = range(1, 2) === 1 ? -1 : 1;
	    this.scale = 1;
	    this.opacity = 1;
	    this.scaleSpeed = range(1000, 3000);
	    this.startTime = Date.now();
	  }
	
	  Shape.prototype.update = function update(mousePos) {
	    this.rotate = this.rotate > 360 ? 0 : this.rotate + this.rotateSpeed;
	    // if (this.scale < 1) {
	    //   var cal = easing(Math.min((Date.now() - this.startTime) / this.scaleSpeed, 1));
	    //   this.scale = 1 * cal;
	    //   this.opacity = 1 * cal;
	    // }
	    if (!mousePos) return;
	    this.x = this.startX + this.rotateDir * (this.distanceX * easing(mousePos.x));
	    this.y = this.startY + this.rotateDir * (this.distanceY * easing(mousePos.y));
	  };
	
	  return Shape;
	}();
	
	var Rectangle = function (_Shape) {
	  _inherits(Rectangle, _Shape);
	
	  function Rectangle(ctx, options) {
	    _classCallCheck(this, Rectangle);
	
	    var _this = _possibleConstructorReturn(this, _Shape.call(this, options));
	
	    _this.ctx = ctx;
	    _this.length = range(20, 50);
	    return _this;
	  }
	
	  Rectangle.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.rotate(this.rotateDir * (this.rotate * Math.PI / 180));
	
	    this.ctx.beginPath();
	    this.ctx.rect(-(this.length / 2), -(this.length / 2), this.length, this.length);
	    this.ctx.stroke();
	    this.ctx.resetTransform();
	  };
	
	  return Rectangle;
	}(Shape);
	
	var Arc = function (_Shape2) {
	  _inherits(Arc, _Shape2);
	
	  function Arc(ctx, options) {
	    _classCallCheck(this, Arc);
	
	    var _this2 = _possibleConstructorReturn(this, _Shape2.call(this, options));
	
	    _this2.ctx = ctx;
	    _this2.radius = range(20, 50);
	    _this2.sAngle = range(30, 90);
	    return _this2;
	  }
	
	  Arc.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.rotate(this.rotateDir * (this.rotate * Math.PI / 180));
	    this.ctx.beginPath();
	
	    this.ctx.arc(0, 0, this.radius, this.sAngle * Math.PI / 180, 2 * Math.PI);
	    this.ctx.stroke();
	    this.ctx.resetTransform();
	  };
	
	  return Arc;
	}(Shape);
	
	var Circle = function (_Shape3) {
	  _inherits(Circle, _Shape3);
	
	  function Circle(ctx, options) {
	    _classCallCheck(this, Circle);
	
	    var _this3 = _possibleConstructorReturn(this, _Shape3.call(this, options));
	
	    _this3.ctx = ctx;
	    _this3.radius = range(20, 50);
	    _this3.sAngle = range(0, 90);
	    return _this3;
	  }
	
	  Circle.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.beginPath();
	    this.ctx.ellipse(0, 0, this.radius, this.radius, 0, 2 * Math.PI, 0);
	    this.ctx.stroke();
	    this.ctx.closePath();
	
	    this.ctx.resetTransform();
	  };
	
	  return Circle;
	}(Shape);
	
	var Triangle = function (_Shape4) {
	  _inherits(Triangle, _Shape4);
	
	  function Triangle(ctx, options) {
	    _classCallCheck(this, Triangle);
	
	    var _this4 = _possibleConstructorReturn(this, _Shape4.call(this, options));
	
	    _this4.ctx = ctx;
	    _this4.length = range(20, 50);
	    _this4.height = _this4.length * (Math.sqrt(3) / 2);
	    return _this4;
	  }
	
	  Triangle.prototype.draw = function draw() {
	    this.ctx.globalAlpha = this.opacity;
	    this.ctx.translate(this.x, this.y);
	    this.ctx.scale(this.scale, this.scale);
	    this.ctx.rotate(this.rotateDir * (this.rotate * Math.PI / 180));
	
	    this.ctx.beginPath();
	    this.ctx.moveTo(0, -this.height / 2);
	    this.ctx.lineTo(-this.length / 2, this.height / 2);
	    this.ctx.lineTo(this.length / 2, this.height / 2);
	    this.ctx.lineTo(0, -this.height / 2);
	    this.ctx.stroke();
	    this.ctx.closePath();
	
	    this.ctx.resetTransform();
	  };
	
	  return Triangle;
	}(Shape);
	
	var FunShapes = function (_PureComponent) {
	  _inherits(FunShapes, _PureComponent);
	
	  function FunShapes() {
	    var _temp, _this5, _ret;
	
	    _classCallCheck(this, FunShapes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this5 = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this5), _this5.state = {}, _this5.setCanvasSize = function () {
	      _this5.canvas.width = _this5.canvas.parentElement.parentElement.offsetWidth;
	      _this5.canvas.height = _this5.canvas.parentElement.parentElement.offsetHeight;
	    }, _this5.onMouseMove = function (e) {
	      _this5.mousePos = {
	        x: (e.x / document.documentElement.clientWidth - .5) * 2,
	        y: (e.y / document.documentElement.clientHeight - .5) * 2
	      };
	    }, _this5.createShapes = function () {
	      _this5.ctx = _this5.canvas.getContext("2d");
	
	      _this5.shapes = Array.from({
	        length: NUM_SHAPES
	      }, function () {
	        switch (range(1, 6)) {
	          case 1:
	            return new Rectangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 2:
	            return new Arc(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 3:
	            return new Circle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 4:
	            return new Triangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 5:
	            return new Triangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	          case 6:
	            return new Rectangle(_this5.ctx, {
	              maxHeight: _this5.canvas.height,
	              maxWidth: _this5.canvas.width
	            });
	        }
	      });
	    }, _this5.drawShapes = function () {
	      if (_this5.isInView()) {
	        _this5.setCanvasSize();
	        // this.ctx.clearRect(0, 0, (this.canvas ? this.canvas.width : 0), (this.canvas ? this.canvas.height : 0));
	        _this5.ctx.strokeStyle = _this5.props.strokeColor;
	        _this5.ctx.lineWidth = 2;
	        _this5.shapes.map(function (shape) {
	          shape.update(_this5.mousePos);
	          shape.draw();
	        });
	      }
	      if (_this5.shapes.length) {}
	      //this.timeoutID = setTimeout(() => {requestAnimationFrame(this.drawShapes)}, 1000/30);
	    }, _this5.isInView = function () {
	      return _this5.canvas && _this5.canvas.getBoundingClientRect().bottom >= 0;
	    }, _temp), _possibleConstructorReturn(_this5, _ret);
	  }
	
	  FunShapes.prototype.componentDidMount = function componentDidMount() {
	    this.setCanvasSize();
	    // window.addEventListener("resize", this.setCanvasSize)
	    window.addEventListener("mousemove", this.onMouseMove);
	    this.createShapes();
	    this.drawShapes();
	    this.mousePos = {
	      x: 0,
	      y: 0
	    };
	  };
	
	  FunShapes.prototype.componentWillUnmount = function componentWillUnmount() {
	    // window.removeEventListener("resize", this.setCanvasSize)
	    window.removeEventListener("mousemove", this.onMouseMove);
	    this.shapes = [];
	    clearTimeout(this.timeoutID);
	  };
	
	  FunShapes.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "funshapes", style: this.props.style },
	      _react2.default.createElement(
	        "canvas",
	        { ref: function ref(el) {
	            return _this6.canvas = el;
	          } },
	        " "
	      )
	    );
	  };
	
	  return FunShapes;
	}(_react.PureComponent);
	
	exports.default = FunShapes;
	module.exports = exports["default"];

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MockScreen = function (_PureComponent) {
	  _inherits(MockScreen, _PureComponent);
	
	  function MockScreen() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MockScreen);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MockScreen.prototype.render = function render() {
	    var _props = this.props,
	        backgroundImage = _props.backgroundImage,
	        imageSrc = _props.imageSrc;
	
	    var style = {},
	        image = void 0,
	        className = '';
	
	    if (backgroundImage) {
	      style = { backgroundImage: "url(" + backgroundImage + ")" };
	      className = " is-background-image";
	    }
	
	    if (imageSrc && !this.props.children) {
	      image = _react2.default.createElement("img", { className: "img-responsive", src: imageSrc, alt: "" });
	      className = ' is-image';
	    }
	
	    if (this.props.children) {
	      image = _react2.default.createElement(
	        "div",
	        { className: "mock-screen__image" },
	        this.props.children
	      );
	      className = ' is-image';
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "mock-screen" },
	      _react2.default.createElement(
	        "div",
	        { className: "mock-screen__top-bar" },
	        _react2.default.createElement("span", null)
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "mock-screen__screen" + className, style: style },
	        image
	      )
	    );
	  };
	
	  return MockScreen;
	}(_react.PureComponent);
	
	exports.default = MockScreen;
	module.exports = exports["default"];

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Col = __webpack_require__(14);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(15);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _MockScreen = __webpack_require__(33);
	
	var _MockScreen2 = _interopRequireDefault(_MockScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorksSingle = function (_PureComponent) {
	  _inherits(WorksSingle, _PureComponent);
	
	  function WorksSingle() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WorksSingle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WorksSingle.prototype.render = function render() {
	    var _props = this.props,
	        work = _props.work,
	        userWorkMeta = _props.userWorkMeta;
	
	
	    var read = userWorkMeta ? userWorkMeta.read : false;
	    if (!work) return null;
	    return _react2.default.createElement(
	      'div',
	      { className: 'work-example', style: { backgroundImage: 'url(' + work.node.frontmatter.image_bg.childImageSharp.sizes.originalImg + ')' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _Row2.default,
	          null,
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'work-example__content' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'work-example__title' },
	                work.node.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'work-example__preview' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  work.node.frontmatter.preview
	                )
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: work.node.fields.slug, className: 'btn btn-white' },
	                'See More'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Col2.default,
	            { className: 'col-xs-12 col-sm-7' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: work.node.fields.slug },
	              _react2.default.createElement(_MockScreen2.default, { backgroundImage: work.node.frontmatter.image_preview.childImageSharp.sizes.originalImg })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return WorksSingle;
	}(_react.PureComponent);
	
	var ReadStatus = function ReadStatus(props) {
	  if (props.read) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'badge badge--read' },
	      'Read'
	    );
	  }
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'badge badge--new' },
	      'New!'
	    )
	  );
	};
	
	exports.default = WorksSingle;
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(23);
	
	var _FunShapes = __webpack_require__(49);
	
	var _FunShapes2 = _interopRequireDefault(_FunShapes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _WorkSingle = __webpack_require__(87);
	
	var _WorkSingle2 = _interopRequireDefault(_WorkSingle);
	
	var _Seo = __webpack_require__(65);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _siteMeta = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkPageList = function (_PureComponent) {
	  _inherits(WorkPageList, _PureComponent);
	
	  function WorkPageList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WorkPageList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WorkPageList.prototype.componentDidMount = function componentDidMount() {
	    this.props.dispatch(_siteMeta.SiteMetaActions.updateSiteMetaColor('#66272E'));
	  };
	
	  WorkPageList.prototype.componentWillUnmount = function componentWillUnmount() {};
	
	  WorkPageList.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'works' },
	      _react2.default.createElement(_Seo2.default, {
	        title: 'Works',
	        url: this.props.pageResources ? this.props.pageResources.page.path : null }),
	      _react2.default.createElement(
	        'div',
	        { className: 'works-hero' },
	        _react2.default.createElement(_FunShapes2.default, { strokeColor: '#E8E2D7' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container is-position' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'works-hero__subtitle' },
	            '2011 - 2018'
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'works-hero__title' },
	            'Past Works'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'works-hero__welcome' },
	            _react2.default.createElement(
	              'h6',
	              null,
	              'Love What You Do, Do What You Love'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'works-hero__arrow' },
	          _react2.default.createElement(_Icon2.default, { id: 'icon-down-arrow' }),
	          _react2.default.createElement(_Icon2.default, { id: 'icon-down-arrow' }),
	          _react2.default.createElement(_Icon2.default, { id: 'icon-down-arrow' })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'works-work-list' },
	        this.props.data.works.edges.map(function (work) {
	          return _react2.default.createElement(_WorkSingle2.default, {
	            key: work.node.fields.slug,
	            work: work });
	        })
	      )
	    );
	  };
	
	  return WorkPageList;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function () {
	  return {};
	})(WorkPageList);
	
	// eslint-disable-next-line
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-works-index-js-e1ff1101bb23eea62ffa.js